module.exports = __webpack_public_path__ + "img/hauptseite-geschichte.39ab254a.jpg";